export default function memberSearch() {
  // Service logic
  // ...

  const meaningOfLife = 42;

  // Public API here
  return {
    someMethod: function () {
      return meaningOfLife;
    }
  };
}
